import { render, staticRenderFns } from "./DashboardGDTH.vue?vue&type=template&id=2763b27c&scoped=true"
import script from "./DashboardGDTH.vue?vue&type=script&lang=js"
export * from "./DashboardGDTH.vue?vue&type=script&lang=js"
import style0 from "./DashboardGDTH.vue?vue&type=style&index=0&id=2763b27c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2763b27c",
  null
  
)

export default component.exports